import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useAppDispatch } from "redux/store";
import { tokenAPICALL } from "services/authService";
import { setJWTToken } from "redux/actions";
import { setError } from "redux/slices/auth";
import { Alert, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux"; 
import { RootState } from "redux/reducers";
import { Constant } from "template/Constant";


const Login: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const rData = useSelector((state: RootState) => state.authToken);
    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        onSubmit: async (values) => {

            let response = new Promise(async function (resolve, reject) {
                const response = await tokenAPICALL(values.username, values.password);
                          
                    if (response) {
                        console.log("28login response28",response.userData)
                        localStorage.setItem("zilla_id",response.userData.zill_id)
                        localStorage.setItem("vibhag_id",response.userData.vibhag_id)
                        localStorage.setItem("nagar_khanda_id",response.userData.nagar_khanda_id)
                        localStorage.setItem("nagar_khanda_id",response.userData.nagar_khanda_id)
                        localStorage.setItem("upamandal_basti_id",response.userData.upamandal_basti_id)
                        localStorage.setItem("log_member_id",response.userData.member_id)
                        localStorage.setItem("log_member_name",response.userData.member_name);
                        localStorage.setItem("log_mobile_num",response.userData.mobile_number);
                        localStorage.setItem("desig_level_id",response.userData.desig_level_id);
                    localStorage.setItem('vibhag_name',response.userData.vibhag_name)
                      localStorage.setItem('zilla_name',response.userData.zilla_name)
                       localStorage.setItem('nagar_khanda_name',response.userData.nagar_khanda_name)
                        localStorage.setItem('upamandal_name',response.userData.upamandal_name)
        //    localStorage.setItem('gramam_name',response.userData.)
                    //     // console.log("44upMandalNamegramamspage",upMandalName)
                      localStorage.setItem('basti_name',response.userData.basti_name)
                        if(response.userData.desig_level_id===7){
                      localStorage.setItem("basti_gramam_type","basti");
                      let basthiGramam =localStorage.getItem("basti_gramam_type");
                      console.log("42loginbasthiGramam",basthiGramam)

                    //    basthiGramam ="basti"
                  
                        }
                console.log("36created_by in loginpage",response.userData.upamandal_basti_id)

                        dispatch(setJWTToken(response));
                       let vibhagId = localStorage.getItem('vibhag_id')
                       let zillaId = localStorage.getItem('zilla_id')
                       let nagarKhandaId = localStorage.getItem('nagar_khanda_id')
                       let upamandal_basthiId= localStorage.getItem('upamandal_basti_id')
                    //    if()
                        if(response.userData.desig_level_id === 3){
                            console.log("logoinjilla_id",vibhagId)
                        navigate('/jillareports/'+vibhagId, { replace: true });
                        }else if (response.userData.desig_level_id === 4){
                        navigate('/nagarkhandareports/'+zillaId, { replace: true });
                        }else if (response.userData.desig_level_id === 5){
                            navigate('/upmandalbasthireports/'+nagarKhandaId, { replace: true });
                            }else if (response.userData.desig_level_id === 6){
                                navigate('/gramamreports/'+upamandal_basthiId, { replace: true });
                                }else if (response.userData.desig_level_id === 7){
                                    navigate('/samithi_members/'+upamandal_basthiId, { replace: true });
                                    }
                                    else{
                                    navigate('/vibhagreports/', { replace: true });
                                    }
                    } else {
                        dispatch(setError("Invalid Credentials"))
                        alert("please enter valid Credentials");
                    }
                    resolve(response);
             
            });
            response.then((resp) => {
               
            });
        },
        validationSchema: yup.object({
            username: yup.string().trim().required('Mobile Number Is Required'),
            password: yup.string().trim().required('Your 4 Digits Login PIN Is Required'),
        }),
    });

    useEffect(() => {
        // document.body.classList.toggle('bg-gradient-primary', true);
        document.body.style.backgroundColor = '#194380';

    }, [])
    return (

        <div className="container"  style={{ color: "5px solid #194380"}}>
            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-12 col-md-7">
                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">
                            <div className="row">
                                {/* <div className="col-lg-6 d-none d-lg-block bg-login-image"></div> */}
                                <div className="col-lg-12">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h1 className="h4 text-gray-900 mb-4">
                                            లోకహితం - జాగరణ మాసపత్రిక, సభ్యత్వ నమోదు 
                                            </h1>
                                        </div>
                                        <Form className="user" onSubmit={formik.handleSubmit}>
                                            <Form.Group>
                                                <label className="form-control-label">Mobile Number *</label>
                                                <Form.Control type="text" name="username" className="form-control-user" value={formik.values.username}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.touched.username && !!formik.errors.username}
                                                    isValid={!!formik.touched.username && !formik.errors.username}
                                                    autoFocus
                                                ></Form.Control>
                                                {formik.errors.username && (
                                                    <Form.Control.Feedback type="invalid">
                                                        <>{formik.errors.username}</>
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            <Form.Group>
                                                <label className="form-control-label">Your 4 Digits Login PIN *</label>
                                                <Form.Control type="password" name="password" className="form-control-user" value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.touched.password && !!formik.errors.password}
                                                    isValid={!!formik.touched.password && !formik.errors.password}
                                                ></Form.Control>
                                                {formik.errors.password && (
                                                    <Form.Control.Feedback type="invalid">
                                                        <>{formik.errors.password}</>
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                            {/* <div className="form-group">
                                                <div className="custom-control custom-checkbox small">
                                                    <input type="checkbox" className="custom-control-input" id="customCheck" />
                                                    <label className="custom-control-label">Remember
                                                        Me</label>
                                                </div>
                                            </div> */}
                                            <br />
                                            <Button type="submit" className="btn-user btn-block" variant="primary" style={{backgroundColor:"#194380",borderColor:"#194380"}}>Login</Button>


                                        </Form> 
                                        <hr />
                                        {rData.errorMessage ?
                                            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.errorMessage}
                                                <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setError(''))}>
                                                    <span aria-hidden="true">&times;</span>
                                                </Button>
                                            </Alert> : null}
                                        {/* <div className="text-center">
                                            <a className="small" href="#">Forgot Password?</a>
                                        </div>
                                        <div className="text-center">
                                            <a className="small" href="#">Create an Account!</a>
                                        </div> */}
                                        <div className="copyright text-center my-auto">
                                            {/* <span>Copyright &copy; nizam_vimukta_team 2022</span> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    );
};

export default Login;

